// @ vendors
const { Promise } = require('es6-promise');
const moment = require('moment');
const get = require('lodash/object/get');
// @ commons
const { APIGet } = require('utilities/APIRequestHelper');
// @ constants
const {
    MORTGAGE_REQUEST_FETCH_UNPAID_FEES_REQUEST,
    MORTGAGE_REQUEST_FETCH_UNPAID_FEES_SUCCESS,
    MORTGAGE_REQUEST_FETCH_UNPAID_FEES_FAILURE,
    MORTGAGE_REQUEST_FETCH_DISABLE_BUTTON_REQUEST,
    MORTGAGE_REQUEST_FETCH_DISABLE_BUTTON_SUCCESS,
    MORTGAGE_REQUEST_FETCH_DISABLE_BUTTON_FAILURE,
    MORTGAGE_REQUEST_RESET_UNPAID_FEES,
    MORTGAGE_REQUEST_FETCH_SET_UNPAID_FEES_FILTER,
    MORTGAGE_REQUEST_FETCH_CLEAR_UNPAID_FEES_FILTER,
    MORTGAGE_REQUEST_FETCH_NEXT_PAGE_UNPAID_FEES_REQUEST,
    MORTGAGE_REQUEST_FETCH_NEXT_PAGE_UNPAID_FEES_SUCCESS,
    MORTGAGE_REQUEST_FETCH_NEXT_PAGE_UNPAID_FEES_FAILURE
} = require('constants/actionTypes');
// @utilities
const UrlHelper = require('utilities/urlHelper');
const { GENERAL_DATA: { PAST_DATE: { YEAR, DAY } } } = require('constants/mortgageRequestMortgageDataTypes');
const { DATE_FORMAT_API } = require('constants/index');

const requestNextPageUnpaidFeesRequest = () => ({
    type: MORTGAGE_REQUEST_FETCH_NEXT_PAGE_UNPAID_FEES_REQUEST,
});

const requestNextPageSuccess = data => ({
    type: MORTGAGE_REQUEST_FETCH_NEXT_PAGE_UNPAID_FEES_SUCCESS,
    data
});

const requestNextPageFailure = error =>({
    type: MORTGAGE_REQUEST_FETCH_NEXT_PAGE_UNPAID_FEES_FAILURE,
    error
})

const requestUnpaidFeesInProgress = () => ({
    type: MORTGAGE_REQUEST_FETCH_UNPAID_FEES_REQUEST,
});

const requestUnpaidFeesSuccess = data => ({
    type: MORTGAGE_REQUEST_FETCH_UNPAID_FEES_SUCCESS,
    data
});

const requestUnpaidFeesFailure = error => ({
    type: MORTGAGE_REQUEST_FETCH_UNPAID_FEES_FAILURE,
    data: {
        error
    }
});

const requestDisableButtonInProgress = index => ({
    type: MORTGAGE_REQUEST_FETCH_DISABLE_BUTTON_REQUEST,
    data: {
        index
    }
});

const requestDisableButtonSuccess =(index, disableButton, feeDetails) => ({
    type: MORTGAGE_REQUEST_FETCH_DISABLE_BUTTON_SUCCESS,
    data: {
        index,
        disableButton,
        feeDetails
    }
});

const requestDisableButtonFailure = index => ({
    type: MORTGAGE_REQUEST_FETCH_DISABLE_BUTTON_FAILURE,
    data: {
        index
    }
});

const requestDisableButton = params => (dispatch, getState) => {
    const unpaidFeesList = getState().mortgageRequestUnpaidFees.get('unpaidFeesList');
    const { movementType, productNumber, contractNumber, currentCount } = params;

    unpaidFeesList.forEach((item, index) => {
        if (!item.get('isFetchingDetail') && index >= currentCount) {
            const requestData = {
                query: {
                    cuota: item.get('number'),
                    codigoMoneda: item.getIn(['value', 'currency']),
                    fechaOnval: item.get('date').format(DATE_FORMAT_API),
                    numeroContrato: contractNumber,
                    producto: productNumber,
                    tipoMovimiento: movementType
                }
            };

            dispatch(requestDisableButtonInProgress(index));

            return APIGet({
                dispatch,
                endpoint: 'mortgageRequestUnpaidFeesDetail',
                params: requestData
            })
                .then(response => {
                    let disableButton, feeDetails;
                    if (response.error) {
                        disableButton = true;
                    } else {
                        disableButton = false;
                        feeDetails = response.listaDetalleCobro.detalleCobro || [];
                    }

                    dispatch(requestDisableButtonSuccess(index, disableButton, feeDetails));
                })
                .catch(response => {
                    if (!!response.error) {
                        dispatch(requestDisableButtonFailure(index));
                    } else {
                        throw response;
                    }
                });
        } else {
            return Promise.resolve()
        }
    });
};

const getUnpaidFees = immLoan => (dispatch, getState) => {
    const currentState = getState().mortgageRequestUnpaidFees;
    const immFilter = currentState.get('filters');
    const isAlreadyFetching = currentState.get('isFetching');
    const pastDate = immFilter.getIn(['date', 'from']) || moment(`${YEAR}-1-${DAY}`, DATE_FORMAT_API).startOf('day');
    const currentDate = immFilter.getIn(['date', 'to']) || moment().startOf('day');
    const contractNumber = immLoan ? immLoan.get('newContractNumber') : 0;
    const productNumber = immLoan ? immLoan.get('newProduct') : 0;

    if (!isAlreadyFetching) {
        const requestData = {
            query: {
                producto: productNumber,
                numeroContrato: contractNumber,
                fechaDesde: pastDate && pastDate.format(DATE_FORMAT_API),
                fechaHasta: currentDate && currentDate.format(DATE_FORMAT_API)
            }
        };

        dispatch(requestUnpaidFeesInProgress());

        return APIGet({
            dispatch,
            endpoint: 'mortgageRequestUnpaidFees',
            params: requestData
        })
        .then(response => {
            const unpaidFeesList = get(response, 'listaCuotasImpagadas.cuotasImpagadas');
            const movementType = get(response, 'tipmvto');
            const isEndOfList = get(response, 'finLista');
            const nextPageURL = get(response, '_links.nextPage.href');

            dispatch(requestUnpaidFeesSuccess({ unpaidFeesList, isEndOfList, nextPageURL }));
            dispatch(requestDisableButton({ movementType, productNumber, contractNumber, currentCount: 0 }));
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(requestUnpaidFeesFailure(response.error))
            } else {
                throw response;
            }
        });
    } else {
        return Promise.resolve()
    }
};

const requestNextTransactionsPage = immLoan => (dispatch, getState) => {
    const immMortgageRequestUnpaidFees = getState().mortgageRequestUnpaidFees;
    const contractNumber = immLoan ? immLoan.get('newContractNumber') : 0;
    const productNumber = immLoan ? immLoan.get('newProduct') : 0;
    const nextPageURL = immMortgageRequestUnpaidFees.get('nextPageURL');
    const currentCount = immMortgageRequestUnpaidFees.get('unpaidFeesList').size;
    const urlParams = UrlHelper.getQueryParams(nextPageURL.split('?')[1]);

    dispatch(requestNextPageUnpaidFeesRequest());

    return APIGet({
        dispatch,
        endpoint: 'mortgageRequestUnpaidFees',
        params: {
            query: urlParams
        }
    })
        .then(response => {
            const unpaidFeesList = get(response, 'listaCuotasImpagadas.cuotasImpagadas');
            const movementType = get(response, 'tipmvto');
            const isEndOfList = get(response, 'finLista');
            const nextPageURL = get(response, '_links.nextPage.href');

            dispatch(requestNextPageSuccess({ unpaidFeesList, isEndOfList, nextPageURL }));
            dispatch(requestDisableButton({ movementType, productNumber, contractNumber, currentCount }));
        })
        .catch(response => {
            if (!!response.error){
                dispatch(requestNextPageFailure(response.error))
            } else {
                throw response;
            }
        });
}

const resetUnpaidFeesState = () => ({
    type: MORTGAGE_REQUEST_RESET_UNPAID_FEES
});

const cleanUnpaidFees = () => dispatch => dispatch(resetUnpaidFeesState());

const setUnpaidFeesFilter = data => ({
    type: MORTGAGE_REQUEST_FETCH_SET_UNPAID_FEES_FILTER,
    data
});

const requestClearUnpaidFeesFilter = () => ({
    type: MORTGAGE_REQUEST_FETCH_CLEAR_UNPAID_FEES_FILTER
});

const clearUnpaidFeesFilter = () => (dispatch, getState) => {
    const immFilter = getState().mortgageRequestUnpaidFees.get('filters');

    const filterActive = immFilter.getIn(['date', 'isActive'])

    if (filterActive) {
        dispatch(requestClearUnpaidFeesFilter());
    }
}

module.exports = {
    getUnpaidFees,
    cleanUnpaidFees,
    setUnpaidFeesFilter,
    clearUnpaidFeesFilter,
    requestNextTransactionsPage
};
